export const isMobileClient = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const userAgent =
    typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase() : "";

  const isMobileUserAgent =
    /iphone|ipad|ipod|android|mobile|windows phone/.test(userAgent);

  return isMobileUserAgent || window.matchMedia("(max-width: 768px)").matches;
};
